export function ScreenTitle(props: { children: React.ReactNode }) {
  return (
    <div className="text-center text-2xl text-white">{props.children}</div>
  );
}
